import React from 'react'
import PropTypes from 'prop-types'

import Markdown from '../../../components/Markdown/Markdown'

export default function PanelFieldTextValue(props) {
  const { value } = props

  return <Markdown>{value}</Markdown>
}

PanelFieldTextValue.propTypes = {
  value: PropTypes.string,
}
